/* global globalThis */
import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";
import { FaCode, FaQuestionCircle } from "react-icons/fa";
import {
  DashboardIcon,
  DataSourceIcon,
} from "../../assets/icon/svgIcons";
import MyLogo from "../../assets/chatbot.png";

// Internal MenuItem component for modular rendering
const MenuItem = ({ to, icon: Icon, label, isActive, title, onClick, iconType = "svg", joyrideClass = "" }) => {
  let iconElement;
  if (iconType === "svg") {
    iconElement = <Icon />;
  } else if (iconType === "img") {
    iconElement = <img src={Icon} alt={label} className="menu-icon w-6 h-6" />;
  } else {
    iconElement = <Icon className="menu-icon" />;
  }

  return (
    <li className={isActive ? "active" : ""}>
      <Link
        className={`flex flex-col items-center sidebar-item-link ${joyrideClass}`}
        to={to}
        title={title}
        onClick={onClick}
      >
        {iconElement}
        <div className="sidebar-label">{label}</div>
      </Link>
    </li>
  );
};

MenuItem.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]).isRequired,
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  title: PropTypes.string,
  onClick: PropTypes.func,
  iconType: PropTypes.oneOf(["svg", "img", "react-icon"]),
  joyrideClass: PropTypes.string,
};

const Sidebar = ({ isOpen }) => {
  const location = useLocation();

  const getPermissions = () => JSON.parse(sessionStorage.getItem("rolesAndPermission") || "{}");
  const [permissions, setPermissions] = React.useState(getPermissions());

  React.useEffect(() => {
    const handlePermUpdate = () => setPermissions(getPermissions());
    globalThis.addEventListener("permissionsUpdated", handlePermUpdate);
    return () => globalThis.removeEventListener("permissionsUpdated", handlePermUpdate);
  }, []);

  const { Dashboard, DataSource, Scriptly } = permissions;

  return (
    <>
      {!isOpen && (
        <div className="sidebar closed">
          <ul className={`sidebar-menu ${isOpen ? "" : "margin-closed"}`}>
            {Dashboard?.canView && (
              <MenuItem
                to="/dashboard"
                icon={DashboardIcon}
                label="Dashboard"
                isActive={location.pathname === "/dashboard"}
                title="Dashboard"
                joyrideClass="sidebar-dashboard-joyride-class"
              />
            )}
            {DataSource?.canView && (
              <MenuItem
                to="/data-sources"
                icon={DataSourceIcon}
                label="Data Sources"
                isActive={location.pathname.includes("/data-sources")}
                title="Data Sources"
                joyrideClass="sidebar-datasource-joyride-class"
              />
            )}
            <MenuItem
              to="/code-gen"
              icon={MyLogo}
              label="BlueGecko AI"
              isActive={location.pathname.includes("/code-gen")}
              title="Bluegecko AI"
              iconType="img"
              joyrideClass="sidebar-ai-joyride-class"
            />
            {Scriptly?.canView && (
              <MenuItem
                to="/scriptly"
                icon={FaCode}
                label="Scriptly"
                isActive={location.pathname.includes("/scriptly")}
                title="Scriptly"
                iconType="react-icon"
                joyrideClass="sidebar-scriptly-joyride-class"
                onClick={() => globalThis.dispatchEvent(new CustomEvent('scriptlySidebarClick'))}
              />
            )}
            <MenuItem
              to="/help"
              icon={FaQuestionCircle}
              label="Help"
              isActive={location.pathname.includes("/help")}
              title="Help"
              iconType="react-icon"
            />
          </ul>
        </div>
      )}
    </>
  );
};

Sidebar.propTypes = {
  isOpen: PropTypes.bool,
};

export default Sidebar;
